import { Component, input, output } from '@angular/core';

export type TableElement = {
  id: number | string;
  name: string;
  description: string;
  hasInfo?: boolean;
};

@Component({
  selector: 'lib-table',
  standalone: true,
  imports: [],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  title = input<number | string | null>(null);
  elements = input.required<TableElement[]>();
  finalElement = input<TableElement | null>(null);
  alternativeRows = input<boolean>(false);
  noBorders = input<boolean>(false);

  infoClicked = output<number | string>();

  onInfoClick(elementId: number | string): void {
    this.infoClicked.emit(elementId);
  }
}
